import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

// ページコンポーネントのインポート
import Auth from '@/pages/auth';
import Dashboard from '@/pages/Dashboard';
import LandingPage from '@/pages/Landing';
import Guidelines from '@/pages/Guidelines';

export default function AppRoutes() {
  const { 
    isAuthenticated, 
    loading, 
    isConfirmationPending  // 追加
  } = useAuthContext();

  // 確認待ちの場合はローディングを表示しない
  if (loading && !isConfirmationPending) {
    return <div className="flex items-center justify-center min-h-screen">読み込み中...</div>;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/app" 
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Auth />} 
      />
      <Route
        path="/dashboard"
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/app" replace />}
      />
      <Route path="/guidelines" element={<Guidelines />} />
      <Route path="*" element={<div>ページが見つかりません</div>} />
    </Routes>
  );
}
